import { t } from '@kanbios/ui';

/**
 * D45: what an unreachable server's SSH error means, in plain words. A timeout
 * is a filtered port (most often the provider's firewall, which the bootstrap
 * cannot open); a refusal is a server that answers without sshd on that port.
 */
export function accessHint(detail?: string | null): string | null {
  if (!detail) return null;
  if (/timed out/i.test(detail)) return t('access.hint.timeout');
  if (/connection refused/i.test(detail)) return t('access.hint.refused');
  if (/no route to host|network is unreachable/i.test(detail)) return t('access.hint.noRoute');
  return null;
}

/** The hint first, then the SSH error as it came. */
export function explainAccess(detail?: string | null): string | null {
  const hint = accessHint(detail);
  return hint ? `${hint} (${detail})` : detail ?? null;
}
